import { Box } from '@/components';
import type { CSSProperties, FC, ReactNode } from 'react';
import { PDF_BORDER, REPORT_BORDER_COLOR } from '../constants';

type Props = {
  cellColRatios?: (number | string)[];
  cellRowRatios?: (number | string)[];
  containedCell: ReactNode;
  includedCell: ReactNode;
  isContainedCellFullHeight?: boolean;
  wrapperStyle?: CSSProperties;
  borderColor?: 'primary' | 'secondary';
};

export const ReportSubsetCells: FC<Props> = ({
  cellColRatios,
  cellRowRatios,
  containedCell,
  includedCell,
  isContainedCellFullHeight = false,
  wrapperStyle,
  borderColor: borderColorType = 'primary',
}) => {
  const borderColor = REPORT_BORDER_COLOR[borderColorType];
  const wrapperLayoutStyles = {
    display: 'grid',
    gridTemplateColumns: (cellColRatios || [1, 1])
      .map((item) => (typeof item === 'number' ? `${item}fr` : item))
      .join(' '),
    gridAutoRows: (cellRowRatios || [1, 1])
      .map((item) => (typeof item === 'number' ? `${item}fr` : item))
      .join(' '),
    height: '100%',
    ...wrapperStyle,
  };

  const parentLayoutStyles = {
    gridColumnStart: 1,
    gridColumnEnd: isContainedCellFullHeight ? 1 : 3,
    gridRowStart: 1,
    gridRowEnd: isContainedCellFullHeight ? 3 : 2,
    height: '100%',
  };

  const childLayoutStyles = {
    gridColumnStart: 2,
    gridRowStart: 2,
    gridRowEnd: 3,
    height: '100%',
  };

  return (
    <Box {...wrapperLayoutStyles} boxSizing="border-box">
      <Box {...parentLayoutStyles}>{containedCell}</Box>
      <Box
        {...childLayoutStyles}
        borderTop={PDF_BORDER.THIN}
        borderLeft={PDF_BORDER.THIN}
        borderColor={borderColor}
        boxSizing="border-box"
      >
        {includedCell}
      </Box>
    </Box>
  );
};
